export default "__VITE_ASSET__Y9HIvuM___"